import type { Dayjs } from 'dayjs'

/**
 * MUI X date fields emit a "valid" Dayjs for every partial year while one is typed (0002, 0020,
 * 0202), so a year below this is still being typed, not picked.
 */
const MIN_PICKED_YEAR = 1900

/**
 * Whether a date field's change is a finished value — cleared, or a valid date with a full year —
 * rather than a keystroke on the way to one. Only a finished value should touch and re-validate
 * the field, or its error would flash while the year is still being typed.
 */
export const isFinishedDatePick = (date: Dayjs | null): boolean => {
  if (date === null) {
    return true
  }

  return date.isValid() && date.year() >= MIN_PICKED_YEAR
}
